// extracted by mini-css-extract-plugin
export default {"icon":"bu_bv"};